import { Link, NavLink } from "react-router-dom";
import { useContext, useState } from "react";
import { AuthContext } from "../context/authContext";

import ButtonNavLink from "./ui/ButtonNavLink";

import ImageNav from '../marca_botonera-01.png';

const NavbarPublic = () => {
    const { user } = useContext(AuthContext);
    const [dark, setDark] = useState(false);

    const toggleTheme = () => {
        setDark(!dark);
        document.body.classList.toggle('dark');
    };

    return (
        <>
        <nav className="flex items-center justify-between px-4 py-2 transition-colors duration-300 ">
            

            <div className="flex items-center space-x-4">             
                {/* Logo por dentro?? */}
                {/* Sección izquierda: Logo y enlaces */}
                <div>
                    {/* Logo */}
                    <img
                        src={ImageNav}
                        alt="Logo empresa"
                        className=""
                    />
                </div>
                
                {/* Enlaces de navegación */}
                <div className="hidden md:flex items-center space-x-4">
                    <NavLink
                        to="/"
                        className={({ isActive }) =>
                            `px-3 py-2 rounded-md text-sm font-medium transition-colors ${isActive
                                ? 'bg-blue-500 text-white'
                                : 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700'
                            }`
                        }
                    >
                        Home
                    </NavLink>

                    {/*<NavLink
                        to="/register"
                        className={({ isActive }) =>
                            `px-3 py-2 rounded-md text-sm font-medium transition-colors ${isActive
                                ? 'bg-blue-500 text-white'
                                : 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700'
                            }`
                        }
                    >
                        Register
                    </NavLink>

                    <NavLink
                        to="/login"
                        className={({ isActive }) =>
                            `px-3 py-2 rounded-md text-sm font-medium transition-colors ${isActive
                                ? 'bg-blue-500 text-white'
                                : 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700'
                            }`
                        }
                    >
                        Login
                    </NavLink>*/}
                </div>
            </div>

            {/* Sección derecha: Contenido opcional y toggle de tema */}
            <div className="flex items-center space-x-6 justify-end">
                {/* Contenido opcional */}
                <div className="text-sm text-gray-700 dark:text-gray-300">
                    {user && `Bienvenido, ${user.name}`}
                </div>                
            </div>
        </nav>
        <div className='flex  flex-grow justify-end items-center'>
            <ButtonNavLink to="/register">Register</ButtonNavLink>
            <ButtonNavLink to="/login">Login</ButtonNavLink>
		</div>
        </>
    );
};

export default NavbarPublic;

